module.exports = __webpack_public_path__ + "files/cabe3e2fed1b3f013e3b8654045600df.png";